const state = {
    listSmall: false,
    payTip: false,
    chooseDate: '' // 选中日期
};
export default state;
